require.context('../images', true);

import 'core-js/stable';
import 'regenerator-runtime/runtime';

import 'normalize.css';
import 'styles/application';

import '../src';
